import { Privilege, User } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';
import { ImportStatus, State } from './state';

const initialState: State = {
    importTextStatus: undefined,
    key: undefined,
    progress: undefined,
    status: ImportStatus.Start,
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.ImportXML:
            return {
                ...state,
                status: ImportStatus.Importing,
            };
        case ActionTypeNames.UpdateImportProgress:
            return {
                ...state,
                importTextStatus: action.text,
                progress: action.progress,
            };
        case ActionTypeNames.ImportSuccess:
            return {
                ...state,
                key: action.key,
                status: ImportStatus.Success
            };
        case ActionTypeNames.ImportError:
            return {
                ...state,
                importTextStatus: action.error.message,
                status: ImportStatus.Error,
            };
        case ActionTypeNames.ClearImportStatus:
            return initialState;
        default:
            return state;
    }
}